/** @format */

import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

import { HOME_CATEGORIES } from './constants';
import useAutoScroll from './useAutoScroll';

import './style.scss';

export default function HomeCategories() {
	const stripRef = useRef(null);
	useAutoScroll(stripRef);

	return (
		<div className="ph-home-categories-container" ref={stripRef}>
			{HOME_CATEGORIES.map((category) => (
				<Link
					key={category.slug}
					to={`/categories/${category.slug}`}
					className="ph-home-categories-item"
					aria-label={category.label}
				>
					<div
						className="ph-home-categories-circle"
						style={{
							background: `linear-gradient(135deg, ${category.gradientFrom}, ${category.gradientTo})`,
						}}
					>
						<img className="ph-home-categories-icon" src={category.image} alt="" />
					</div>
					<span className="ph-home-categories-label">{category.label}</span>
				</Link>
			))}
		</div>
	);
}
